import React, { useState } from 'react';
import Modal from '../../../../../../../components/Modal/Modal';
import BaseForm from '../../../../../../../components/form/BaseForm/BaseForm';
import DateSinglePicker from '../../../../../../../components/datePicker/DateSinglePicker';
import { DATE_FORMAT } from '../../../../../../../constants/service/common/utilConstants';
import Slider from '../../../../../../../components/utils/Slider/Slider';
import Img from '../../../../../../../components/Img/Img';
import moment, { setDateFormat } from '../../../../../../../lib/moment';
import { checkIsBetween } from '../../../../../../../lib/common';
import { WidgetItemEvent } from '../../../../../../../types/widget';
import { EventPreviewWrapStyle, EventWidgetPreviewModalStyle } from './style';

interface EventPreviewWrapProps {
  list: Partial<WidgetItemEvent>[];
}

const EventPreviewWrap = (props: EventPreviewWrapProps): JSX.Element => {
  const { list } = props;

  return (
    <EventPreviewWrapStyle>
      <Slider
        emptyText="위젯에 노출중인 기획전이 없습니다."
        list={list}
        arrows={false}
        infinite={false}
        item={(item: Partial<WidgetItemEvent>): JSX.Element => (
          <div className="event-image">
            <Img clickAble={false} src={item.mobileImage?.[0]?.url || ''} />
          </div>
        )}
      />
    </EventPreviewWrapStyle>
  );
};

interface EventWidgetPreviewModalProps {
  closeModal: () => void;
  list: Partial<WidgetItemEvent>[];
}

const EventWidgetPreviewModal = (props: EventWidgetPreviewModalProps): JSX.Element => {
  const { closeModal, list } = props;
  const [exposureDate, setExposureDate] = useState(setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT));

  const currentTimeEventList = list.filter((widgetItem) =>
    checkIsBetween(
      DATE_FORMAT.FULL_DASH_FORMAT,
      widgetItem.exposurePeriod?.startDate,
      widgetItem.exposurePeriod?.endDate,
    ),
  );

  const settingTimeEventList = list.filter((widgetItem) =>
    checkIsBetween(
      DATE_FORMAT.FULL_DASH_FORMAT,
      widgetItem.exposurePeriod?.startDate,
      widgetItem.exposurePeriod?.endDate,
      exposureDate,
    ),
  );

  return (
    <Modal
      title="기획전 미리보기"
      isOpen={true}
      width={870}
      height={650}
      isFooter={true}
      overflow="hidden"
      onOk={closeModal}
      onClose={closeModal}
    >
      <EventWidgetPreviewModalStyle>
        <BaseForm
          className="exposure-period"
          label="노출 설정 시점"
          content={
            <DateSinglePicker
              value={exposureDate}
              showTime={true}
              outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
              format={DATE_FORMAT.FULL_DASH_FORMAT}
              onSelect={setExposureDate}
            />
          }
        />

        <div className="preview-area">
          <div className="before">
            <div className="title">현재 시점 노출</div>

            <EventPreviewWrap list={currentTimeEventList} />
          </div>

          <div className="after">
            <div className="title">설정된 시점 노출</div>

            <EventPreviewWrap list={settingTimeEventList} />
          </div>
        </div>
      </EventWidgetPreviewModalStyle>
    </Modal>
  );
};

export default EventWidgetPreviewModal;
